export default function Index() {
  return (
    <div className="prose-sm prose xl:prose-lg mx-auto max-w-5xl">
      <h1>Datenschutzerklärung</h1>
      <h2>1. Allgemeines</h2>
      <p>
        Diese Datenschutzerklärung informiert die Nutzer von Onzeit.com über die
        Art, den Umfang und Zwecke der Erhebung und Verwendung personenbezogener
        Daten durch den Websitebetreiber (siehe{" "}
        <a className="large-text" href="/impressum">
          Impressum
        </a>
        ).
      </p>
      <p>
        Wir nehmen Ihren Datenschutz sehr ernst und behandeln Ihre
        personenbezogenen Daten vertraulich und entsprechend der gesetzlichen
        Vorschriften. Da sich diese Datenschutzerklärung durch die
        Weiterentwicklung unserer Website und Angebote darüber oder durch
        geänderte gesetzliche bzw. behördliche Vorgaben ändern kann, empfehlen
        wir, sie regelmäßig zu lesen.
      </p>
      <h2>2. Zugriffsdaten</h2>
      <p>
        Wir, der Websitebetreiber bzw. Seitenprovider, erheben Daten über
        Zugriffe auf die Seite und speichern diese als „Server-Logfiles“ ab.
        Folgende Daten werden so protokolliert:
      </p>
      <ul>
        <li>
          <p>Besuchte Website</p>
        </li>
        <li>
          <p>Uhrzeit zum Zeitpunkt des Zugriffes</p>
        </li>
        <li>
          <p>Menge der gesendeten Daten in Byte</p>
        </li>
        <li>
          <p>Quelle/Verweis, von welchem Sie auf die Seite gelangten</p>
        </li>
        <li>
          <p>Verwendeter Browser</p>
        </li>
        <li>
          <p>Verwendetes Betriebssystem</p>
        </li>
        <li>
          <p>Verwendete IP-Adresse</p>
        </li>
      </ul>
      <p>
        Die erhobenen Daten dienen lediglich statistischen Auswertungen und zur
        Verbesserung der Website. Der Websitebetreiber behält sich allerdings
        vor, die Server-Logfiles nachträglich zu überprüfen, sollten konkrete
        Anhaltspunkte auf eine rechtswidrige Nutzung hinweisen.
      </p>
      <h2>3. Umgang mit personenbezogenen Daten</h2>
      <p>
        Der Websitebetreiber erhebt, nutzt und gibt Ihre personenbezogenen Daten
        nur dann weiter, wenn dies im gesetzlichen Rahmen erlaubt ist oder Sie
        in die Datenerhebung einwilligen.
      </p>
      <p>
        Als personenbezogene Daten gelten sämtliche Informationen, welche dazu
        genutzt werden können, Ihre Person zu identifizieren, und die zu Ihnen
        zurückverfolgt werden können – also beispielsweise Ihr Name, Ihre
        E-Mail-Adresse und Telefonnummer.
      </p>
      <h2>4. Umgang mit Kontaktdaten</h2>
      <p>
        Nehmen Sie mit uns als Websitebetreiber durch die angebotenen
        Kontaktmöglichkeiten Verbindung auf, werden Ihre Angaben gespeichert,
        damit auf diese zur Bearbeitung und Beantwortung Ihrer Anfrage
        zurückgegriffen werden kann. Ohne Ihre Einwilligung werden diese Daten
        nicht an Dritte weitergegeben.
      </p>
      <h2>5. Google Analytics</h2>
      <p>
        Diese Website nutzt aufgrund unserer berechtigten Interessen zur
        Optimierung und Analyse unseres Online-Angebots im Sinne des Art. 6 Abs.
        1 lit. f. DSGVO den Dienst „Google Analytics“, welcher von der Google
        Inc. (1600 Amphitheatre Parkway Mountain View, CA 94043, USA) angeboten
        wird. Der Dienst (Google Analytics) verwendet „Cookies“ – Textdateien,
        die auf Ihrem Endgerät gespeichert werden. Die durch die Cookies
        gesammelten Informationen werden im Regelfall an einen Google-Server in
        den USA gesandt und dort gespeichert.
      </p>
      <p>
        Google LLC hält das europäische Datenschutzrecht ein und ist unter dem
        Privacy-Shield-Abkommen zertifiziert. Diese Website verwendet Google
        Analytics nur mit aktivierter IP-Anonymisierung. Das bedeutet, die
        IP-Adresse der Nutzer wird von Google innerhalb von Mitgliedstaaten der
        Europäischen Union oder in anderen Vertragsstaaten des Abkommens über
        den Europäischen Wirtschaftsraum gekürzt. Nur in Ausnahmefällen wird die
        volle IP-Adresse an einen Server von Google in den USA übertragen und
        dort gekürzt.
      </p>
      <p>
        Im Auftrag des Betreibers dieser Website wird Google diese Informationen
        benutzen, um Ihre Nutzung der Webseite auszuwerten, um Reports über die
        Webseitenaktivitäten zusammenzustellen und um weitere, mit der
        Webseitennutzung und der Internetnutzung verbundene Dienstleistungen,
        gegenüber dem Webseitenbetreiber zu erbringen. Die im Rahmen von Google
        Analytics von Ihrem Browser übermittelte IP-Adresse wird nicht mit
        anderen Daten von Google zusammengeführt.
      </p>
    </div>
  );
}
